import img1 from "../assets/gallery/Mongolia/mongolia1.jpg";
import img2 from "../assets/gallery/Mongolia/mongolia2.jpg";
import img3 from "../assets/gallery/Mongolia/mongolia3.jpg";
import img4 from "../assets/gallery/Mongolia/mongolia4.jpg";
import img5 from "../assets/gallery/Mongolia/mongolia5.jpg";
import img6 from "../assets/gallery/Mongolia/mongolia6.jpg";
import img7 from "../assets/gallery/Mongolia/mongolia7.jpg";
import img8 from "../assets/gallery/Mongolia/mongolia8.jpg";
import img9 from "../assets/gallery/Mongolia/mongolia9.jpg";
import img10 from "../assets/gallery/Mongolia/mongolia10.jpg";
import img11 from "../assets/gallery/Mongolia/mongolia11.jpg";
import img12 from "../assets/gallery/Mongolia/mongolia12.jpg";
import img13 from "../assets/gallery/Mongolia/mongolia13.jpg";
import img14 from "../assets/gallery/Mongolia/mongolia14.jpg";
import img15 from "../assets/gallery/Mongolia/mongolia15.jpg";
import img16 from "../assets/gallery/Mongolia/mongolia16.jpg";
import img17 from "../assets/gallery/Mongolia/mongolia17.jpg";
import img18 from "../assets/gallery/Mongolia/mongolia18.jpg";
import img19 from "../assets/gallery/Mongolia/mongolia19.jpg";
import img20 from "../assets/gallery/Mongolia/mongolia20.jpg";
import img21 from "../assets/gallery/Mongolia/mongolia21.jpg";
import img22 from "../assets/gallery/Mongolia/mongolia22.jpg";
import img23 from "../assets/gallery/Mongolia/mongolia23.jpg";
import img24 from "../assets/gallery/Mongolia/mongolia24.jpg";
import img25 from "../assets/gallery/Mongolia/mongolia25.jpg";
import img26 from "../assets/gallery/Mongolia/mongolia26.jpg";
import img27 from "../assets/gallery/Mongolia/mongolia27.jpg";
import img28 from "../assets/gallery/Mongolia/mongolia28.jpg";
import img29 from "../assets/gallery/Mongolia/mongolia29.jpg";
import img30 from "../assets/gallery/Mongolia/mongolia30.jpg";

const mongoliaGallery = [
  { img: img1, rowSpan: 2 },
  { img: img2 },
  { img: img3 },

  { img: img4 },
  { img: img5 },
  { img: img6, rowSpan: 2 },

  { img: img7, colSpan: 2 },

  { img: img8 },
  { img: img9, rowSpan: 2 },
  { img: img10 },

  { img: img11 },
  { img: img12 },
  { img: img13 },

  { img: img14, colSpan: 2 },
  { img: img15 },

  { img: img16 },
  { img: img17, rowSpan: 2 },
  { img: img18 },

  { img: img19, colSpan: 2 },

  { img: img20 },
  { img: img21 },
  { img: img22 },

  { img: img23, rowSpan: 2 },
  { img: img24 },
  { img: img25 },

  { img: img26, colSpan: 2 },
  { img: img27 },

  { img: img28 },
  { img: img29, rowSpan: 2 },
  { img: img30 },
];

export default mongoliaGallery;
